import {
  APPLY_FILTER,
  CLEAR_RECENT_SEARCH,
  REMOVE_SELECTED_RECENT,
  RESET_FILTER,
  SET_MAX_PRICE_FILTER,
  SET_TYPE_FILTER,
  SET_REGION_FILTER,
  SET_PROVINCE_FILTER,
  SET_MIN_PRICE_FILTER,
  SET_NPA_FILTER,
  SET_SUB1_FILTER,
  SET_TEXT_FILTER,
  SET_WEIGHT_FILTER,
  SET_WHEELS_FILTER,
  SET_ASSISTED_FILTER,
  SET_YEAR_FILTER,
  SET_BRAND_FILTER,
  SET_SIZE_FILTER
} from '../../constants/constants';

export const setTextFilter = (keyword) => ({
  type: SET_TEXT_FILTER,
  payload: keyword
});

export const setTypeFilter = (type) => ({
  type: SET_TYPE_FILTER,
  payload: type
});

export const setSub1Filter = (sub1) => ({
  type: SET_SUB1_FILTER,
  payload: sub1
});

export const setYearFilter = (year) => ({
  type: SET_YEAR_FILTER,
  payload: year
});

export const setBrandFilter = (brand) => ({
  type: SET_BRAND_FILTER,
  payload: brand
});

export const setSizeFilter = (size) => ({
  type: SET_SIZE_FILTER,
  payload: size
});

export const setWheelsFilter = (wheels) => ({
  type: SET_WHEELS_FILTER,
  payload: wheels
});

export const setWeightFilter = (weight) => ({
  type: SET_WEIGHT_FILTER,
  payload: weight
});

export const setAssistedFilter = (assisted) => ({
  type: SET_ASSISTED_FILTER,
  payload: assisted
});

export const setRegionFilter = (region) => ({
  type: SET_REGION_FILTER,
  payload: region
});

export const setProvinceFilter = (province) => ({
  type: SET_PROVINCE_FILTER,
  payload: province
});

export const setNpaFilter = (npa) => ({
  type: SET_NPA_FILTER,
  payload: npa
});

export const setMinPriceFilter = (min) => ({
  type: SET_MIN_PRICE_FILTER,
  payload: min
});

export const setMaxPriceFilter = (max) => ({
  type: SET_MAX_PRICE_FILTER,
  payload: max
});

export const resetFilter = () => ({
  type: RESET_FILTER
});

export const clearRecentSearch = () => ({
  type: CLEAR_RECENT_SEARCH
});

export const removeSelectedRecent = (keyword) => ({
  type: REMOVE_SELECTED_RECENT,
  payload: keyword
});

export const applyFilter = (filters) => ({
  type: APPLY_FILTER,
  payload: filters
});
